// 导入你的公共配置
import {
  textDefaultData,
  articleTableHeaders,
  carouselTableHeaders,
  dialogTableHeaders,
  actionButtons,
  sidebarNavData,
  predefineColors,
  wordSizeOptions,
  fontFamilyOptions,
  searchOptions,
} from "@/utils/defaultData.js";

// 导出全局混入对象
export default {
  data() {
    return {
      // 把所有公共数据挂载到data中
      textDefaultData,
      articleTableHeaders,
      carouselTableHeaders,
      dialogTableHeaders,
      actionButtons,
      sidebarNavData,
      predefineColors,
      wordSizeOptions,
      fontFamilyOptions,
      searchOptions,
    };
  },
};
